var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBusinessFreedom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 0C7.93303 0 7.67857 0.254463 7.67857 0.571429V2.28571H16.25V0.571429C16.25 0.254457 15.9955 0 15.6786 0H8.25ZM2.82143 3.42857C1.39731 3.42857 0.25 4.57589 0.25 6V8.51786C2.86606 9.93526 6.40629 10.8929 10.366 11.0982C10.6138 10.4553 11.2343 9.99997 11.9642 9.99997C12.6953 9.99997 13.3247 10.4542 13.5714 11.0982C17.5279 10.8917 21.0648 9.93414 23.6785 8.51786V6C23.6785 4.57589 22.5312 3.42857 21.1071 3.42857H2.82143ZM0.25 9.80343V17.4286C0.25 18.8527 1.39731 20 2.82143 20H21.1071C22.5313 20 23.6786 18.8527 23.6786 17.4286V9.80343C20.9431 11.1661 17.4531 12.0456 13.5983 12.2409C13.3751 12.9295 12.7266 13.4284 11.9643 13.4284C11.2021 13.4284 10.5626 12.9295 10.3393 12.2409C6.48106 12.0467 2.98791 11.1661 0.2502 9.80343H0.25Z",
    fill: "#2E84FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessFreedom);
export default __webpack_public_path__ + "static/media/business-freedom.c6ab351de97839639d94cac6baf79a1f.svg";
export { ForwardRef as ReactComponent };